import React, { useEffect, useState } from "react"
import "./category.css"
import { category } from "../../assets/data/data"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"
import { GrFormPrevious } from "react-icons/gr"
import { MdNavigateNext } from "react-icons/md"
import axios from "axios"
import { useLocation } from "react-router-dom"
import { Link } from "react-router-dom"

const SampleNextArrow = (props) => { 
  const { onClick } = props
  return (
    <div className='control-btn' onClick={onClick}>
      <button className='next'>
        <MdNavigateNext className='icon' />
      </button>
    </div>
  )
}
const SamplePrevArrow = (props) => {
  const { onClick } = props
  return (
    <div className='control-btn' onClick={onClick}>
      <button className='prev'>
        <GrFormPrevious className='icon' />
      </button>
    </div>
  )
}
export const Category = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
     autoplay: true,
  autoplaySpeed: 2100,
  pauseOnHover: true,

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    arrows: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  }

  const [cats, setCat] = useState([])
  const { search } = useLocation()

  useEffect(() => {
    // const getCat = async () => {
    //   const res = await axios.get("http//localhost:5000/category" + search)
    //   setCat(res.data)
    // }
    // getCat()
  }, [search])
  return (
    <>
      <section className='category'>
        <div className='content'>
          <Slider {...settings}>
            {category.map((item) => (
              <div className='boxs'>
                <div className='box' key={item.id}>
                  <img src={item.cover} alt='cover' />
                  {item.category !== "" && (
                    <div className='overlay'>
                      <Link to={`/?cat=${item.name}`} className='link'>
                        <h4 className="card_category">{item.category}</h4>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  )
}
